<template>
  <div class="page container p-4 py-4">
    <ForgotPasswordFlow
      mode="standalone"
      :isAuthenticated="false"
      :onSuccess="handleSuccess"
      :onCancel="handleCancel"
    />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import ForgotPasswordFlow from '@/components/ForgotPasswordFlow.vue';

const router = useRouter();

function handleSuccess() {
  router.push('/login');
}

function handleCancel() {
  router.push('/login');
}
</script>

<style scoped>
</style>